// Libraries
import { ReactNode } from 'react';

// Styles
import styles from './WinnersTable.module.css';

/**
 * @function WinnersTable
 * Describe the component's function
 *
 * @example
 * return (
 *   <WinnersTable title={''}></WinnersTable>
 *
 * )
 */
function WinnersTable({ title, children }: WinnersTableProps): JSX.Element {
    return (
        <>
            <h2 className={styles.heading}>
                <picture className={styles.picture}>
                    <img
                        src={`https://${process.env.REACT_APP_CDN}/play-bingo/images/graphics/graphic-winner.svg`}
                        alt=""
                    />
                </picture>
                <span>{title}</span>
            </h2>
            <div className={styles.container}>
                <table className={styles.winners}>{children}</table>
            </div>
        </>
    );
}

/**
 * @interface WinnersTableProps
 * Describes the properties required for the WinnersTable component
 *
 * @property {strng} title
 * @property {array} winners
 * @property {ReactNode} children
 */
export interface WinnersTableProps {
    title: string;
    children: ReactNode;
}

// Exports
export default WinnersTable;
